import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { MaterialSymbol } from './material-symbol';

const BadgeArea = styled.div`
  color: white;
  background-color: var(--theme-color-primary);
  border-radius: 5px;
  font-size: 14px;
  padding: 0 3px;
  display: inline-flex;
`;

const InsideBadge = styled.div`
  display: flex;
  align-items: center;
  margin: 5px;
`;

const BadgeText = styled.div`
  margin-left: 5px;
  font-weight: bold;
`;

interface TimeLeftType {
  hours?: number;
  minutes?: number;
  seconds?: number;
  days?: number;
}

export const Badge = ({ text }: { text: string }) => {
  const [timeLeft, setTimeLeft] = useState<TimeLeftType>({});
  const [displayCountdown, setDisplayCountdown] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const now = new Date().getTime();
      const distance = new Date(text).getTime() - now;

      if (distance < 0) {
        clearInterval(intervalId);
        setTimeLeft({});
        setDisplayCountdown(false);
      } else if (distance < 86400000) {
        // moins de 24h
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        setTimeLeft({ hours, minutes, seconds });
        setDisplayCountdown(true);
      } else if (distance < 604800000) {
        // moins d'une semaine
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        setTimeLeft({ days });
        setDisplayCountdown(true);
      } else {
        // plus d'une semaine
        clearInterval(intervalId);
        setTimeLeft({});
        setDisplayCountdown(false);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [text]);

  const { hours, minutes, seconds, days } = timeLeft;

  return (
    <BadgeArea>
      {displayCountdown ? (
        <InsideBadge>
          <MaterialSymbol symbol="alarm" fill={1} weight={800} size={16} />
          {hours && minutes && seconds && <BadgeText>{`${hours}h ${minutes}m ${seconds}s`}</BadgeText>}
          {days && !hours && !minutes && !seconds && <BadgeText>{`${days} jours`}</BadgeText>}
        </InsideBadge>
      ) : null}
    </BadgeArea>
  );
};
